module.exports = __webpack_public_path__ + "static/media/lobby.24a77a39.mp3";